import { withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

const SectionHeading = withTypography({
  variant: 'headerTwo',
  color: primitive.$bbqBrown,
  fontSize: 'xl',
  style: {
    marginBottom: spacing.$3,
    marginTop: spacing.$5,
  },
  focusable: true,
});

export default SectionHeading;
